/**
 * vendor
 */
import React, { useEffect, useRef } from 'react';

/**
 * PALTFORM MODULE
 */
import { default as PlatformCsrfService }    from '@shared/services/session/services/CsrfService';

function CsrfLoad() {
  const serviceRef = useRef(null);
  const componentLikeRef = useRef(null);

  useEffect(() => {
    // Create component-like object for service
    const componentLike = {
      setState: () => {},
      state: {}
    };

    componentLikeRef.current = componentLike;
    serviceRef.current = new PlatformCsrfService(componentLike);

    serviceRef.current.registerCsrfEvents(componentLike, serviceRef.current);

    return () => {
      if (serviceRef.current) {
        serviceRef.current.removeCsrfEvents();
      }
    };
  }, []);

  return (<></>);
}

export default CsrfLoad;
